<script lang="ts" setup>
  import { BngToast } from './components'

  const { toast, scroll } = storeToRefs(useUiStore())

  const pageContent = useTemplateRef('pageContent')

  const router = useRouter()

  onMounted(() => {
    router.afterEach(() => {
      pageContent.value?.scrollTo(0, 0)
    })
  })
</script>

<template>
  <div class="l-iframe">
    <BngToast
      iframe
      :content="toast"
      @close="() => null"
    />
    <div
      id="layout-observer-root"
      ref="pageContent"
      class="page-content"
      :class="{ 'no-scroll': !scroll }"
    >
      <slot />
    </div>
    <div id="modal-booking" />
    <div id="modal" />
    <div id="reservation-banner" />
  </div>
</template>

<style scoped>
.l-iframe {
  position: relative;
  display: flex;
  overflow: hidden;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100 - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  min-height: 100vh;
  min-height: calc(var(--vh, 1vh) * 100 - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  flex-direction: column;
  background-color: #eef0f1;

  .page-content {
    position: relative;
    display: flex;
    overflow: hidden auto;
    flex: 1 1 auto;
    flex-direction: column;
  }

  .no-scroll {
    overflow: hidden;
    height: calc(100% - 3.25em);
  }

  @media all and (width <= 360px) {
    font-size: 0.85em;
  }
}
</style>
